import { FlexBox, Text } from '@dixa/lib-shared-habla';

import { ExpressionError } from 'apis/auditLogs';
import styles from './expressionErrors.module.scss';

type ExpressionErrorsProps = {
  errors?: readonly ExpressionError[] | null;
};

export function ExpressionErrors({
  errors,
}: ExpressionErrorsProps): JSX.Element | null {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <FlexBox gap="100" padding="0 0 0 100" alignItems="flex-start">
      <Text.Paragraph variant="2" subdued className={styles.connector}>
        └
      </Text.Paragraph>
      <FlexBox flexDirection="column" gap="200" className={styles.content}>
        {errors.map((error, index) => (
          <FlexBox key={index} flexDirection="column" gap="100">
            <Text.Paragraph variant="2" color="error" className={styles.error}>
              Expression error · {error.error_type}: {error.message}
            </Text.Paragraph>
            <pre className={styles.codeBlock}>{error.expression}</pre>
          </FlexBox>
        ))}
      </FlexBox>
    </FlexBox>
  );
}
